let $win = $(window);
let body = $('body');
let width = $win.width();
let mailIsCorrect = false;

$.fn.quickChange = function(handler) {
    return this.each(function() {
        let self = this;
        self.qcindex = self.selectedIndex;
        let interval;
        function handleChange() {
            if (self.selectedIndex !== self.qcindex) {
                self.qcindex = self.selectedIndex;
                handler.apply(self);
            }
        }
        $(self).focus(function() {
            interval = setInterval(handleChange, 100);
        }).blur(function() { window.clearInterval(interval); })
        .change(handleChange); //also wire the change event in case the interval technique isn't supported (chrome on android)
    }); 
};

let vacationStartDate = "2018-11-18", // some start date
	 vacationEndDate  = "2018-12-04",  // some end date
	 vacationDateRange = [];           // array to hold the range

// populate the array
for (let d = new Date(vacationStartDate); d <= new Date(vacationEndDate); d.setDate(d.getDate() + 1)) {
	vacationDateRange.push($.datepicker.formatDate('yy-mm-dd', d));
}

let vacationDays = function(date) {
	let dateString = jQuery.datepicker.formatDate('yy-mm-dd', date);
	return [vacationDateRange.indexOf(dateString) === -1];
};

$(function() {
	
	$('img.fancybox').each( function() {
		
		let $img = $(this);
		let link = document.createElement('a');
		link.href = $img.attr('data-original-src') ? $(this).attr('data-original-src') : this.src;
		link.className = 'fancybox';
		link.title = $img.attr('title');
		
		$img.wrap(link);
		
		if($img.hasClass('zoom')) {
			$img.after('<span class="zoom" title="zvětšit obrázek"></span>');
			$img
				.parent()
					.removeClass()
					.addClass(this.className)
					.end()
				.removeClass();
				
			if($img.parent().hasClass('border')) {
				$img
					.addClass('border')
					.parent().removeClass('border');
			}
		}
	});

	$('a.fancybox').swipebox();
	
	$.datepicker.regional['cs'] = {
		closeText: 'Zavřít', 
		prevText: '&#x3c;Dříve',
		nextText: 'Později&#x3e;',
		currentText: 'Nyní',
		monthNames: ['leden','únor','březen','duben','květen','červen', 'červenec','srpen','září','říjen','listopad','prosinec'],
		monthNamesShort: ['led','úno','bře','dub','kvě','čer', 'čvc','srp','zář','říj','lis','pro'],
		dayNames: ['neděle', 'pondělí', 'úterý', 'středa', 'čtvrtek', 'pátek', 'sobota'],
		dayNamesShort: ['ne', 'po', 'út', 'st', 'čt', 'pá', 'so'],
		dayNamesMin: ['ne','po','út','st','čt','pá','so'],
		weekHeader: 'Týd',
		dateFormat: 'dd.mm.yy',
		firstDay: 1,
		isRTL: false,
		showMonthAfterYear: false,
		yearSuffix: ''};
	$.datepicker.setDefaults($.datepicker.regional['cs']);
	
	$('.date').datepicker({
		showOtherMonths: true,
		selectOtherMonths: true,
		onClose: function() {
			$(this).blur();
		},
		beforeShowDay: vacationDays
	});
	$('.date', '#ParkingForm, .rezervation-box').datepicker('option', 'minDate', 'now');
	
	$('input.r').blur(function(){
		if(!this.value.length || this.value === 'hod:min')
			$(this).addClass('ui-input-error');
		else
			$(this).removeClass('ui-input-error');
	}).keyup( function() {
		let $this = $(this);
		if($this.is('.ui-input-error') && $this.val().length)
			$this.removeClass('ui-input-error');
	});
	$('input[type="email"]').blur(function() {
		if(this.value.length) {
			if(!this.value.match(/^[a-zA-Z0-9_.-]{1,50}@([a-z0-9-]{1,63}\.){1,}[a-z]{2,}$/))
				$(this).addClass('ui-input-error');
			else
				$(this).removeClass('ui-input-error');
		}
	});
	
	/*$(document).tooltip({
		items: '[data-help]',
		position: { my: 'left bottom', at: 'left top', collision: 'flipfit' },
		show: { duration: 'fast' },
		content: function() {
			return $(this).attr('data-help');
		}
	});*/
	
	$('.captcha').each(function() {
		$(this).append('<input type="hidden" name="i_am_human" value="1">').parent().hide();
	});
	
	$('.encodedEmail').each( function() {
		let $self = $(this);
		let data = $self.attr('data-data').split(/,/);
		
		$self.removeClass('encodedEmail');		
		$self.replaceWith(DecodeEmail(data[0], data[1], $self.attr('class')));
	});
	
	$('a.print').click( function() {
		window.print();
		return false;
	});
	
	/*$('.faq').accordion({
		'heightStyle': 'content'
	});*/
	
	let timeout = isIE6 || isIE7 ? 2000 : 1;
	setTimeout( function() {
		$('.box ul.list.reference').owlCarousel({
			singleItem: true,
			pagination: false,
			autoHeight: true
		});
		$('.bottom-header .slides').owlCarousel({
			singleItem: true,
			autoPlay: 2000,
			pagination: true,
			transitionStyle: 'fade',
			slideSpeed: 600,
			rewindSpeed: 600,
			mouseDrag: false,
			touchDrag: false
		});
	}, timeout);
	
	$('.reference-navigation .next').click( function() {
		$('ul.list.reference').trigger('owl.next');	
		return false; 
	});
	$('.reference-navigation .prev').click( function() {
		$('ul.list.reference').trigger('owl.prev');	
		return false;
	});

	let times = $('#from_time, #to_time');
	
	times.change( function() {
		$(this).parent().find('.hm').val( this.options[this.selectedIndex].innerHTML ).blur();
	}).blur( function() {
		$(this).parent().find('.hm').val( this.options[this.selectedIndex].innerHTML ).blur();
	});
	
	times.quickChange( function() {
		$(this).parent().find('.hm').val( this.options[this.selectedIndex].innerHTML );
	});
			
	$('.rezervation-box').submit( function() {
		let isOK = true;
		if(!$('input[name=from_date]', this).val().length) {
			$('.row-from label', this).after('<span class="ui-inline-error">Vyplňte prosím datum příjezdu k nám</span>');
			isOK = false;
		}
		if(!$('input[name=to_date]', this).val().length) {
			$('.row-to label', this).after('<span class="ui-inline-error">Vyplňte prosím datum příletu</span>');
			isOK = false;
		}		
		return isOK;
	});
	
	let airportCache = {};
	$('#ParkingForm #airport_name').autocomplete({
		minLength: 3,
		position: { my : "right top", at: "right bottom" },
		appendTo: '#AirportMenu',
      source: function( request, response ) {
        $('#parking_airport_id').val('');
        	
        let term = request.term;
        if ( term in airportCache ) {
          response( airportCache[ term ] );
          return;
        }
 
        $.getJSON( $('#ParkingForm').attr('data-airporturl'), request, function( data, status, xhr ) {
          airportCache[ term ] = data;
          response( data );
        });
      },
      focus: function(event, ui) {
        $('#airport_name').val(ui.item.name + ' (' + ui.item.iata_code + '), ' + ui.item.country_name);
        return false;
      },
      select: function(event, ui) {
        $('#airport_name').val(ui.item.name + ' (' + ui.item.iata_code + '), ' + ui.item.country_name);
        $('#parking_airport_id').val(ui.item.id);
        return false;
      },
      create: function() {
			$(this).data('ui-autocomplete')._renderItem = function(ul, item) {
			  return $('<li>')
			    .attr('data-value', item.id)
			    .append($('<a>').html('<b>'+item.name+' ('+item.iata_code+')</b>, ' + item.country_name))
			    .appendTo(ul);
			};
		}
	});
	
	$('#ParkingForm').submit(function() {
		if(!mailIsCorrect)
		{
			$('#EmailDialog .bold').html($('#ParkingForm #email').val());
			$('#EmailDialog').dialog({
				modal: true,
				width: 570,
				resizable: false,
				draggable: false,
				dialogClass: 'email-dialog',
				buttons: {
					'Opravit e-mail': function() {
						$(this).dialog( "close" );
          			$('#email').focus().select();
					},
					'Ano, je správně': function() {
						$( this ).dialog( "close" );
						mailIsCorrect = true;
						$('#ParkingForm').submit();
					}
				},
				open: function() {
					$('.ui-button').removeClass('ui-state-hover').blur();	
				}
			});
			return false;
		}
	});
	
	$('#ParkingForm #want_cleaning').click( function() {
		if(this.checked) 
		{
			OpenCleaningSettings();
		}
		else 
		{
			$('#cleaningSettings').val('');	
			$('#CleaningOrderText').html('');
			$('#ChangeCleaning').addClass('hidden');
		}
	});
	$('#ChangeCleaning a').click( function() {
		return OpenCleaningSettings();
	});
	$('#CleaningInfoLink').click( OpenCleaningInfo );
	$('input[name=cleaning_variant]').click(function() {
		$('.complementary-service input').attr('disabled', false);
		let include = $(this).parents('tr').eq(0).data('include').split(',');
		for(let i = 0; i < include.length; i++) {
			$('input#' + include[i]).prop('checked', false).attr('disabled', true);
		}
	});
	 
	$('input#suv').click(function() {
		let key = $(this).is(':checked') ? 'suvprice' : 'price';
		
		$('#CleaningDialog input[data-price]').each(function() {
			$(this).parents('tr').eq(0).find('td, th').last().html($(this).data(key)+' Kč');
		})
	});

	let parkingForm = $('.rezervation-box, #ParkingForm');
	let $inputs = parkingForm.find('input[type="text"], input[type="date"], select');
	let calculateUrl = parkingForm.attr('data-calculateurl');
	
	if(calculateUrl && calculateUrl.length)
	{
		$inputs.attr('autocomplete', 'off');
		$inputs.change( function() { 
			let $form = $(this).parents('form');
			
			$form.find('.ui-inline-error').remove();
			
			if($form.find('input[name=from_date], #from_date').eq(0).val().length) 
			{
				if($form.find('input[name=to_date], #to_date').eq(0).val().length) 
				{
					let dateFrom, dateTo;
					
					if($form.find('#from_time').length && $form.find('#to_time').length) {
						if(!$form.find('#from_time').val().length || !$form.find('#to_time').val().length)
							return;
							
						dateFrom = $form.find('input[name=from_date], #from_date').eq(0).val() + ' ' + $form.find('#from_time').val();
						dateTo = $form.find('input[name=to_date], #to_date').eq(0).val() + ' ' + $form.find('#to_time').val();
					}
					else {
						dateFrom = $form.find('input[name=from_date], #from_date').eq(0).val() + ' 00:00:00';
						dateTo = $form.find('input[name=to_date], #to_date').eq(0).val() + ' 00:00:01';
					}

					let voucherElm = $('#voucher');
					let voucher = voucherElm.val() || '';
					
					$.getJSON( calculateUrl, { 'dateFrom': dateFrom, 'dateTo': dateTo, 'voucher': voucher }, function(data) {
						if(data.status === 'success') {
							$form.find('.price-info .colored-text').html(data.price_formated);
							$form.find('.days-info').find('.colored-text').html(data.diff);
							//$('.price-summary').removeClass('hidden');
							$form.find('.price-info, .days-info, .xbtn-continue').removeClass('hidden');
							//$('.btn-calc').addClass('hidden');
							$form.find('#priceInput').val(data.price);
						}
						else {
							$form.find('.price-summary').find('.colored-text', '.price-info, .day-info').html('?');
							$form.find('.price-info, .days-info, .xbtn-continue').addClass('hidden');
							//$('.btn-calc').removeClass('hidden');
							//$('.price-summary').addClass('hidden');
							if(typeof data.errors.common != 'undefined')
							{
								let summaryPrice = $('.price-summary');
								if(!summaryPrice.length)
									$('.price-info').after('<div class="ui-inline-error">' + data.errors.common + '</div>');
								else
									summaryPrice.before('<div class="ui-inline-error">' + data.errors.common + '</div>');
							}
						}
						
						if(data.voucher.status === 'error') {
							voucherElm.val('');
							if(!$('.price-summary').length)
								$('#voucher').before('<div class="ui-inline-error">' + data.voucher.error + '</div>');
							else
								$('#voucher').after('<div class="ui-inline-error">' + data.voucher.error + '</div>');
						}
						if(data.voucher.status === 'success') {
							$('.sale-info')
								.removeClass('hidden')
								.find('.red').html(data.discount);
						}
						else {
							$('.sale-info')
								.addClass('hidden')
								.find('.red').html('');
						}
					});
				}
				else
				{
					$form.find('.price-summary').find('.colored-text', '.price-info, .day-info').html('?');
					$form.find('.price-info, .days-info, .xbtn-continue').addClass('hidden');
					//$('.btn-calc').removeClass('hidden');
				}
			}
			else
			{
				$form.find('.price-summary').find('.colored-text', '.price-info, .day-info').html('?');
				$form.find('.price-info, .days-info, .xbtn-continue').addClass('hidden');
				//$('.btn-calc').removeClass('hidden');
			}
		});
	}
	
	if(typeof $.fn.masonry != 'undefined')
	{
		$('.content ul.reference').masonry({
			itemSelector: 'li',
			gutter: $('.reference-space-size').width()
		});
	}
	
	$('.main-menu-toggle').click( function() {
		$('.main-menu').toggleClass('expanded');
		$(this).toggleClass('hover');
	});
	
	
	$win.resize( function() {
		SwitchLayout();
	});
	
	setTimeout( function() {
		SwitchLayout(true);
	}, 100);
	
	if(typeof InitializeGoogleMap == 'function')
	{
		InitializeGoogleMap();
		
		if(typeof navigator.geolocation == 'undefined')
			$('#CurrentAddress').hide();
		else
			$('#CurrentAddress').click( GMapSetCurrentAddress );
			
		$('#PlanFromCurrentPosition').click( GMapCalculateRoute );
	}
	
	if(body.is('.ie6') || body.is('.ie7'))
		$('.list-seven').removeClass();
		
	$('#YourDemandForm').submit(function() {
		let isValid = true;
		let messages = [];
		
		$(this).find('[required]').each( function() {
			let $input = $(this);
			let $label = $input.prev();
					
			if(!this.value.length) 
			{
				isValid = false;
				messages.push($label.text().replace(/: \*/, '')+' je povinná položka.');
				$input.addClass('ui-input-error');
			}
			else if($(this).attr('type') === 'email' && !this.value.match(REGEXP_EMAIL))
			{
				isValid = false;
				messages.push($label.text()+' musí být platný e-mail.');
				$input.addClass('ui-input-error');
			}
		});
		
		$(this).find('.attachment').each( function(index) {
			if(this.value.length && !this.value.match(/(jpe?g|gif|png|pdf)$/)) {
				isValid = false;
				messages.push('Příloha musí být soubor typu jpg, gif, png, nebo pdf (soubor '+(index+1)+').');
			}
		});
		
		if(!$('#conditions').is(':checked')) {
			isValid = false;
			messages.push('Pro odeslání musíte souhlasit se zpracováním osobních údajů.');	
		}
		
		if(!isValid)
		{
			let $div = $('<div class="nowrap fs13 red"></div>');
			$div.html(messages.join('<br>'));
			$div.dialog({
				modal: true,
				draggable: false,
				resizable: false,
				width: 600,
				title: 'Formulář obsahuje chyby'
			});
			
			return false;
		}
	});
	
	$('#YourDemandForm input[required]').blur( function() {
		$(this).toggleClass('ui-input-error', !this.value.length);
	});
	
	$('.condition-link').click( function() {
		$('#conditions-text').dialog({
			modal: true,
			draggable: false,
			resizable: false,
			width: 730
		});
		return false;
	});

	let shareBox = $('.share-box');
	if(shareBox.length)
	{
		let articleOffset = $('article.content').offset().top;
		function setSharePosition() {
			let top = $(window).scrollTop();
			if(top > articleOffset) {
				shareBox.css('top', Math.ceil(top - articleOffset + 20) + 'px');
			}
			else {
				shareBox.css('top', 0);
			}
		}
		
		$.event.add(window, 'scroll', setSharePosition);
		setSharePosition();
	}
	
	$(document).on('mouseover mouseout', '.rating form label', function(event) {
 			$(this).parent().find('span').removeClass('fa-star').addClass('fa-star-o');
 			
 			if(event.type === 'mouseover') {
				$('span', this).toggleClass('fa-star-o fa-star');	
				$(this).prevAll('label').find('span').toggleClass('fa-star-o fa-star');
 			}
 			else {
				$(this).parent().find('span.active').toggleClass('fa-star-o fa-star');
 			}
 		})
		.on('click', '.rating form input[type=radio]', function() {
			let $form = $(this).parents('form').eq(0);
			$.ajax({
				url: $form.attr('action'),
				data: $form.serialize(),
				type: 'post',
				dataType: 'json',
				success: function(data) {
					$('.rating').replaceWith(data.html);
				}
			});
		});
	  	
	InitMessages();
	Inquiry.init();
	Newsletter.init('');
	Newsletter.init('Article');
});

function SwitchLayout(force)
{
	if($win.width() === width && !force)
		return;
	
	width = $win.width();
	
	let $hw = $('.how-it-work');
	if(width <= 900) {
		/*$('input, textarea', 'fieldset').each( function() {
			$(this).attr('placeholder', $('label[for="'+this.id+'"]').text());
		});*/
		$('input.date').each( function() {
			let $elm = $(this);
			if($elm.attr('type') === 'text')
			{
				$elm
					.prop('type', 'date')
					.datepicker('option', 'showOn', 'button')
					.val($elm.attr('data-sqlval'));
			}
		});
	}
	else {
		/*$('input, textarea', 'fieldset').each( function() {
			$(this).attr('placeholder', '');
		});*/
		$('input.date').prop('type', 'text').datepicker('option', 'showOn', 'focus');
	}
}

function OpenCleaningSettings()
{
	$('#CleaningDialog').dialog({
		modal: true,
		width: 570,
		resizable: false,
		draggable: false,
		buttons: {
			'Zrušit (nechci umýt auto)': function() {
				$$('want_cleaning').checked = false;
				$('#cleaningSettings').val('');	
				$('#CleaningOrderText').html('');
				$('#ChangeCleaning').addClass('hidden');
				$(this).dialog( "close" );
			},
			'Objednat mytí': function() {
				$('#CleaningOrderText').html('<ul></ul>');
				$('#ChangeCleaning').removeClass('hidden');
				
				let cleaningOrder = {};
				let totalPrice = 0;
				let $checked = $(this).find(':checked');
				
				if(!$checked.length) {
					alert('Vyberte prosím alespoň jednu službu.');
					return false;
				}
				
				let isSUV = $('input#suv').is(':checked');
				cleaningOrder['suv'] = isSUV;
				
				$checked.each( function() {
					if(this.id === 'suv') {
						$('#CleaningOrderText ul').append('<li>Mám SUV / MPV</li>');
					}
					else {
						let name = $(this).attr('data-name');
						let price = $(this).attr(isSUV ? 'data-suvprice' : 'data-price');
						
						cleaningOrder[this.value] = {
							'name': name,
							'price': price
						};
						totalPrice += Number(price);
						
						$('#CleaningOrderText ul').append('<li>'+name+' ('+price+' Kč)</li>');
					}
				});
				
				cleaningOrder['totalPrice'] = totalPrice;
				$('#CleaningOrderText ul').append('<li><strong>CELKEM:</strong> '+totalPrice+' Kč</li>');
				
				$('#cleaningSettings').val(JSON.stringify(cleaningOrder));
				$(this).dialog( "close" );				
			}
		},
		open: function() {
			$('.ui-button').removeClass('ui-state-hover').blur();	
			$(this).closest('.ui-dialog').find('.ui-button').eq(2).addClass('orange');
			$(this).find('input').blur();
		}
	});
	return false;
}

function OpenCleaningInfo()
{
	$('#CleaningInfoDialog').dialog({
		modal: true,
		width: 570,
		resizable: false,
		draggable: false,
		buttons: {
			'Zpět': function() {
				$(this).dialog( "close" );
			},
		},
		open: function() {
			$('.ui-button').removeClass('ui-state-hover').blur();	
			$(this).closest('.ui-dialog').find('.ui-button').eq(1).addClass('orange long');
		}
	});
	return false;
}

function OpenReasons()
{
	$('#SevenReasons').slideToggle('slow');
}

function InitMessages()
{
	$(".ui-message:not(.not-closable)").append('<a href="#" class="ui-message-close">Zavřít</a>');	
	$(".ui-message-close").click(function() {
		$(this).parent().slideToggle();
		return false;
	});	
}

function getCaptchaCode(hash, $context)
{
	$.ajax({
		'url': '/captcha.php?action=get&hash='+hash,
		'type': 'get',
		'dataType': 'html',
		'success': function(data) {
			$context.find('#captchaCode').val(data);
		},
		'error': function() {
			$context.find('#captchaCode').val('');
			$context.show();	
			$context.parents('.captchaContainer').eq(0).show();
		}
	});
}

/**
 * @param email
 * @param label
 * @param className
 * @returns {string}
 * @constructor
 */
function DecodeEmail(email, label, className)
{
   let AntiSpamChars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789@.-_=?%';

	let decodedData = {'email':'', 'label':''};
	let encodedData = {'email':email, 'label':label};

	for(key in encodedData)
	{
		let k = 0;
		let Char = null;

		let value = encodedData[key];
		if(!value)
		   continue;

		for(let i = 0; i < value.length; i++)
		{
			Char = value.charAt(i);
			let CharIdx = AntiSpamChars.indexOf(Char);

			k = k > 6 ? 0 : k;

			switch(k)
			{
				case 0: CharIdx -= AntiSpamChars.indexOf('M'); break;
				case 1: CharIdx -= AntiSpamChars.indexOf('a'); break;
				case 2: CharIdx -= AntiSpamChars.indexOf('r'); break;
				case 3: CharIdx -= AntiSpamChars.indexOf('t'); break;
				case 4: CharIdx -= AntiSpamChars.indexOf('h'); break;
				case 5: CharIdx -= AntiSpamChars.indexOf('a'); break;
				case 6: CharIdx -= AntiSpamChars.indexOf('s'); break;
			}

			k++;

			CharIdx = CharIdx < 0 ? AntiSpamChars.length+CharIdx : CharIdx;

			decodedData[key] += AntiSpamChars.charAt(CharIdx);
		}
		decodedData[key] = decodeURIComponent(decodedData[key]);
	}

	return '<a href="mailto:'+decodedData['email']+'" target="_blank"'+(className ? 'class="'+className+'"' : '')+'>'+decodedData['label']+'</a>';
}

function PerformAjax(url, data, success, error)
{
	$.ajax({
		url: url,
		cache: false,
		type: 'POST',
		dataType: 'json',
		data: data,
		success: function(data)
		{
			success(data);
		},
		error: function()
		{
			error();
		}
	});	
}

function DisplayLoading($container, append)
{
	if(append) {
		$container.append('<img src="/res/img/ajax-loader.gif" width="20" height="20" alt="" title="" class="ajaxLoader">');
	}
	else {
		$container.removeClass('hidden').html('<img src="/res/img/ajax-loader.gif" width="20" height="20" alt="" title="" class="ajaxLoader">');
	}	
	$container.find('img').css({
		'margin-top': $container.height() / 2 - 15,
		'margin-left': $container.width() / 2 - 15
	});
}

function AjaxCommonError()
{
	let $loader = $('img.ajaxLoader');
	let $errorMessage = $('#AjaxCommonError').clone();
	$errorMessage.removeClass('hidden');
	
	$loader.replaceWith($errorMessage);	
	InitMessages();
}



let Inquiry = {
	
	init: function() {
	
		$('.inquiry-progress').each( function() {
			$bar = $(this);
			$bar.css({
				'width': $bar.attr('data-width'),
				'background-color': $bar.attr('data-color')
			});
		});
		
		$(document).on('click', '.inquiry-answer a', Inquiry.vote);
	},
	
	vote: function() {
		let $this = $(this);
		let inquiryId = $this.attr('data-inquiryid');
		let vote = $this.attr('data-vote');
		let target = $this.attr('data-target');
		
		let url = ReplaceUrl({'inquiryId': inquiryId, 'vote': vote, 'isAjaxVote': 1});
		$.getJSON(url, function(data) {
			Inquiry.voteCallback(data, target);
		});
		
		$(target).find('.inquiry-answer a').each( function() {
			$(this).replaceWith($(this).text());
		});
		
		return false;
	},
	
	voteCallback: function(data, target) {
		
		let $target = $(target);
		
		$target.find('.inquiry-total-votes').html(data.total_votes);
		$target.prepend(data.messages);
		
		let $answers = $target.find('li');
		
		for(k in data.votes) {
			let index = k - 1;
			let percentage = Number(data.votes[k].total) * Number(data.percentage);
			
			$answers.eq(index)
				.find('.inquiry-vote-count').html(data.votes[k].total).end()
				.find('.inquiry-progress')
					.css('width', Math.round(percentage) + '%')
					.attr('title', Math.round(percentage) + '%');
		}
		
		InitMessages();
	}
};

let Newsletter = {
	
	suffix: '',
	
	init: function(suffix)
	{				
		let sel = suffix + '';
		
		$('#NewsletterForm' + sel).find('form').submit( function() {
			let $inputs = $(this).find('#InputsNewsletter, #InputsNewsletterArticle');
			DisplayLoading($inputs, true);
			
			$inputs
				.find('.button').hide().end()
				.find('.ajaxLoader').css({'margin': '0 0 0 10px', 'vertical-align': 'middle'});
			
			let data = {
				form : {
					email : $(this).find('.field').val()
				}
			};
			
			Newsletter.suffix = sel;
			
			PerformAjax(this.action + '?isAjax=1', data, Newsletter.subscribeCallback, Newsletter.subscribeCallback);
			return false;			
		});
	},
	
	subscribeCallback : function(data) {
		let sel = Newsletter.suffix;
		
		$('#MessagesNewsletter' + sel).html(data.messages);
		InitMessages();	
		
		if(data.status === 'success')
			$('#NLEmail' + sel).val('').blur();
			
		$('#InputsNewsletter' + sel)
			.find('.ajaxLoader').remove().end()
			.find('.button').show();
	}
};

let js, fjs;
setTimeout( function() {
	if($('.fb-like, .fb-page').length)
	{
		(function(d, s, id) {
		  fjs = d.getElementsByTagName(s)[0];
		  if (d.getElementById(id)) return;
		  js = d.createElement(s); js.id = id;
		  js.src = "//connect.facebook.net/cs_CZ/all.js#xfbml=1&appId=626228134105134";
		  fjs.parentNode.insertBefore(js, fjs);
		}(document, 'script', 'facebook-jssdk'));
	}
	$.getScript('//s7.addthis.com/js/300/addthis_widget.js#pubid=ra-512f395b64655d26');
	 
	//!function(d,s,id){let js,fjs=d.getElementsByTagName(s)[0],p=/^http:/.test(d.location)?'http':'https';if(!d.getElementById(id)){js=d.createElement(s);js.id=id;js.src=p+'://platform.twitter.com/widgets.js';fjs.parentNode.insertBefore(js,fjs);}}(document, 'script', 'twitter-wjs');
}, 500); 

if(typeof connect_click == 'function') {
	connect_click('danaglozova', 30);
}

if(typeof initClickHeat == 'function') {
	clickHeatSite = 'parkovanir7.cz';
	clickHeatGroup = encodeURIComponent(window.location.pathname+window.location.search);
	clickHeatServer = 'http://az015.az-servery.cz/clickheat/click.php';
	initClickHeat();
}
